export default __webpack_public_path__ + "static/media/At_penny_bank_this_year.301661f9.png";